module.exports = __webpack_public_path__ + "img/base-course.de04f270.png";